import React from "react"

import truncate from "lodash/truncate"
import PropTypes from "prop-types"
import { useHistory } from "react-router-dom"

import { TEEUP_TITLE_LENGTH } from "@utils/contacts"

import { Wrapper, Arrow, TeeupName } from "./goBackStyles"

// TEEUP-INSIDE 2026-07-03: `compact` renders the back arrow only -- the title now lives in its
// own centered <Title> row (Ale's .detail-hero shape has the name below the chip, not inline
// with the back arrow). Non-compact usage kept for any other consumer of GoBack.
export const GoBack = ({ name, compact }) => {
  const history = useHistory()

  const handleGoBack = () => {
    history.push("/inbox")
  }

  return (
    <Wrapper onClick={handleGoBack} data-testid="teeup-detail-back">
      <Arrow name="arrow-2" color="var(--white)" />

      {!compact && (
        <TeeupName>{truncate(name, { length: TEEUP_TITLE_LENGTH })}</TeeupName>
      )}
    </Wrapper>
  )
}

GoBack.propTypes = {
  name: PropTypes.string,
  compact: PropTypes.bool,
}
